var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-player-panel",style:({width: _vm.realWidth,height: _vm.realHeight, maxWidth: _vm.maxWidth+'px'})},[_c('div',{staticClass:"in-player",class:{'is-out-course': _vm.outCourse},attrs:{"id":_vm.playerId}})])}
var staticRenderFns = []

export { render, staticRenderFns }